import React, { createContext, useContext, useMemo, useState } from 'react'

const AdminContext = createContext(null)

const useAdmin = () => {
  const context = useContext(AdminContext)
  if (!context) {
    throw new Error('useAdmin must be used within a AdminProvider')
  }
  return context
}

const AdminProvider = props => {
  const [admin, setAdmin] = useState(null)
  // `can('VIEW_COMPANIES')` — whether the signed-in admin holds a permission; several names mean any of them
  const value = useMemo(
    () => ({ admin, setAdmin, can: (...permissions) => !!admin && permissions.some(p => (admin.permissions || []).includes(p)) }),
    [admin]
  )

  return <AdminContext.Provider value={value} {...props} />
}

export { AdminProvider, useAdmin }
